// https://vuex.vuejs.org/en/getters.html

export default {
  currentUserSub : state => {
    return state.userInfo.attributes.sub;
  },

  authToken : state => {
    return state.userInfo.signInUserSession.idToken.jwtToken;
  }
}
